<template>
    <div ref="wrapper">
        <div class="wrapper">
            <img @mouseenter="mouseenterHandle" @mouseleave="mouseleaveHandle" @click="handleClick" class="owner" :src="ownerImage" alt="owner" />
            <el-collapse-transition>
                <div ref="wrapperChild" :class="theme" v-show="visibility" class="content spacing">
                    <div class="descrip">{{ $t(title) }}</div>
                    <div class="tools">
                        <template v-for="(o, index) in tools">
                            <div style="position:relative;" @mouseenter="hoverIndex = index" @mouseleave="hoverIndex = ''" @click="openUrlHandle(o.link)" class="range" :key="index">
                                <img :src="o.darkImageUrl || getImgUrl(o)" />
                                <div>{{ util$.getI18nLabel$(o.i18n, "langCode", "title") }}</div>
                                <transition name="el-fade-in-linear">
                                    <div v-show="hoverIndex === index" style="height:100%;width:100%;position:absolute;left:0px;top:0px;backgroundColor: rgba(154, 206, 215, 0.1);borderRadius:4px;"></div>
                                </transition>
                            </div>
                        </template>
                    </div>
                </div>
            </el-collapse-transition>
        </div>
    </div>
</template>

<script>
import myToolConfig from './my-tool-config.js'
let watchInstances = []
export default {
    data () {
        return {
            toogle: myToolConfig.toogle,
            theme: myToolConfig.theme,
            visibility: false,
            ownerImage: '',
            title: myToolConfig.title,
            tools: [],
            hoverIndex: '',
        }
    },
    watch: {
        visibility (value) {
            if (value) {
                this.$refs.wrapperChild.style.paddingTop = '20px'
                this.$refs.wrapperChild.style.paddingBottom = '30px'
                this.ownerImage = this.toogle.active
            } else {
                this.ownerImage = this.toogle.normal
            }
        }
    },
    methods: {
        handleClickBlank (e) {
            if (!this.$refs.wrapper.contains(e.target)) {
                this.visibility = false
            }
        },
        handleClick () {
            this.visibility = !this.visibility
        },
        mouseenterHandle () {
            if (!this.visibility) {
                this.ownerImage = this.toogle.hover
            }
        },
        mouseleaveHandle () {
            if (!this.visibility) {
                this.ownerImage = this.toogle.normal
            }
        },
        openUrlHandle(url) {
            this.visibility = false
            window.open(url)
        },
        getImgUrl (item) {
            return myToolConfig.mppingImg[ item.name ]
        }
    },
    created () {
        const ins = this.$watch('toolsKey', value => {
            try {
                if (typeof value === 'object') {
                    this.tools = JSON.parse(  JSON.stringify ( value )  )
                } else if (typeof value === 'string') {
                    this.tools = JSON.parse(  value  )
                } else {
                    throw ''
                }
            } catch (e) {
                this.tools = []
            }
        }, { immediate: true })
        this.ownerImage = this.toogle.normal
        watchInstances.push(ins)
    },
    mounted () {
        document.addEventListener('click', this.handleClickBlank, false)
    },
    beforeDestroy () {
        watchInstances.forEach(watchInstance => typeof watchInstance === 'function' && watchInstance())
        document.removeEventListener('click', this.handleClickBlank, false)
    }
}
</script>

<style scoped>
.black {
    background-color: #333333;
    color: #ffffff;
    border: solid 1px #000000;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.06);

}
.white {
    background-color: #ffffff;
    color: #333333;
    border: solid 1px #dcdfe6;
    box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.1);

}
.wrapper {
    width: 40px;
    height: 40px;
    position: relative;
    border-radius: 50%;
    line-height: normal;
    font-size: 14px;
}
.owner {
    width: 100%;
    height: 100%;
}
.content {
    width: 344px;
    border-radius: 4px;
    position: absolute;
    right: -5px;
    top: 45px;
    z-index: 2005;
}
.spacing {
    padding: 20px 30px 30px 30px;
    text-align: center;
   
}
.descrip {
    height: 20px;
    font-size: 14px;
}
.range {
    width: 137px;
    border-radius: 8px;
    padding-bottom: 15px;
}

.range img {
    width: 137px;
    height: 92px;
}
.range div {
    font-size: 14px;
}
.tools {
    margin-top: 15px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
</style>
